import { combineReducers } from 'redux';
import getTruckReducerSlice from './reducerSlices/getTruckReducer';
import getLoadReducerSlice from './reducerSlices/getLoadReducer';
import FiltersReducerSlice from './reducerSlices/FiltersReducerSlice';
import DateSelectorReducer from './reducerSlices/DateSelectorReducer';
import AuthReducer from './reducerSlices/AuthReducer';
import CommentsReducerSlice from './reducerSlices/CommentsReducerSlice';
import POReducer from './reducerSlices/POReducer';
import DockListReducer from './reducerSlices/DockListReducer';
import AssignDockReducer from './reducerSlices/AssignDockReducer';
import DefaultDashboardReducer from './reducerSlices/DefaultDashboardReducer';
import SuperAdminReducerSlice from './reducerSlices/SuperAdminReducerSlice';
import RemoteConfigReducerSlice from './reducerSlices/RemoteConfigReducer';
import UserReducer from './reducerSlices/UserReducer';

import HelpAndFeedBackReducer from "./reducerSlices/HelpAndFeedbackReducer";
import FileUploadReducer from "./reducerSlices/FileuploadReducer";
import CompanyGroupReducer from "./reducerSlices/CompanyGroupReducer";
import CompanyReducer from "./reducerSlices/CompanyReducer";
import GetWarehouseDataReducer from "./reducerSlices/GetWarehouseDataReducer";
import GetLumpingFaciltyReducer from "./reducerSlices/GetLumpingFaciltyReducer";
import GetTaxCodeReducer from "./reducerSlices/GetTaxCodeReducer";
import GetTimeZoneReducer from "./reducerSlices/GetTimeZoneReducer";
import GetWareHouseLocationList from "./reducerSlices/GetWareHouseLocationList";
import GetCountryListReducer from "./reducerSlices/GetCountryListReducer";
import AddWarehouseReducer from "./reducerSlices/AddWarehouseReducer";
import ReportsReducerSlice from './reducerSlices/ReportsReducerSlice';
import SendEmailForAppointment from './reducerSlices/sendEmailForAppointment';
import PaytraceReducer from './reducerSlices/PaytraceReducer';
import POSSReducerSlice from './reducerSlices/POSmartSchedulerReducer';
import SmartScheduleReducerSlice from './reducerSlices/SmartScheduleReducer';
import WhMetaDataReducerSlice from './reducerSlices/WhMetaDataReducerSlice';
import UserPaymentsReducerSlice from './reducerSlices/UserPaymentsReducerSlice';
import DriverCheckinReducer from "./reducerSlices/DriverCheckinReducer";
import CheckInReducer from './reducerSlices/CheckInReducer';
import ScheduleUploadStatus from './reducerSlices/ScheduleUploadReducer';
import EclipseOpsPaymentLoadReducer from './reducerSlices/EclipseOpsPaymentLoadReducer';
import FsWarehouseReducer from './reducerSlices/FsWarehouseReducer';
import GatePassReducer from './reducerSlices/GatePassReducer';
import PoIntakeMangementReducer from './reducerSlices/PoIntakeMangementReducer';
import CSCEReducer from './reducerSlices/CSCEReducer';
import GetLivChatLogDetails from "./reducerSlices/GetLiveChatLogDetails";
import ExcelPoFileReducer  from './reducerSlices/ExcelPoFileReducer';
import SmsMessageLogReducer from './reducerSlices/SmsMessageLogReducer';
import CommodityReducer  from './reducerSlices/CommodityReducer';
import DmsBucketReducer from './reducerSlices/DmsBucketReducer';
import MyReportsReducer from './reducerSlices/MyReportsReducer';
import SproCarrierManagementReducer from './reducerSlices/SproCarrierManagementReducer';
import TTPaymentLogReducer from './reducerSlices/TTPaymentLogReducer';
import ReleaseBannerReducer from './reducerSlices/ReleaseBannerReducer';
import ReleaseBannerAdminReducer from './reducerSlices/ReleaseBannerAdminReducer';

const appReducer = combineReducers({
  getTruckReducer: getTruckReducerSlice,
  filterReducer: FiltersReducerSlice,
  getLoadReducer: getLoadReducerSlice,
  dateSelectorReducer: DateSelectorReducer,
  authReducer: AuthReducer,
  commentsReducer: CommentsReducerSlice,
  poReducer: POReducer,
  getDockList: DockListReducer,
  assignDockReducer: AssignDockReducer,
  defaultDashboardReducer: DefaultDashboardReducer,
  remoteConfigReducer: RemoteConfigReducerSlice,
  userReducer: UserReducer,
  helpAndFeedBackReducer: HelpAndFeedBackReducer,
  superAdminReducerSlice: SuperAdminReducerSlice,
  fileUploadReducer: FileUploadReducer,
  CompanyGroupReducer: CompanyGroupReducer,
  CompanyReducer: CompanyReducer,
  GetWarehouseDataReducer: GetWarehouseDataReducer,
  GetLumpingFaciltyReducer: GetLumpingFaciltyReducer,
  GetTaxCodeReducer: GetTaxCodeReducer,
  GetTimeZoneReducer: GetTimeZoneReducer,
  GetWareHouseLocationList: GetWareHouseLocationList,
  GetCountryListReducer: GetCountryListReducer,
  AddWarehouseReducer: AddWarehouseReducer,
  reportsReducerSlice: ReportsReducerSlice,
  SendEmailForAppointment: SendEmailForAppointment,
  smartScheduleReducer: SmartScheduleReducerSlice,
  PaytraceReducer: PaytraceReducer,
  pOSSReducerSlice: POSSReducerSlice,
  whMetaDataReducerSlice: WhMetaDataReducerSlice,
  userPaymentsReducerSlice: UserPaymentsReducerSlice,
  DriverCheckinReducer: DriverCheckinReducer,
  getCheckIn: CheckInReducer,
  scheduleUploadStatus: ScheduleUploadStatus,
  eclipseOpsPaymentLoadReducer: EclipseOpsPaymentLoadReducer,
  FsWarehouseReducer: FsWarehouseReducer,
  GatePassReducer: GatePassReducer,
  PoIntakeMangementReducer: PoIntakeMangementReducer,
  CSCEReducer: CSCEReducer,
  GetLivChatLogDetails: GetLivChatLogDetails,
  ExcelPoFileReducer:ExcelPoFileReducer,
  smsMessageLog: SmsMessageLogReducer,
  CommodityReducer: CommodityReducer,
  dmsBucket: DmsBucketReducer,
  myReportsReducer: MyReportsReducer,
  sproCarrierManagementReducer: SproCarrierManagementReducer,
  ttPaymentLogReducer: TTPaymentLogReducer,
  releaseBannerReducer: ReleaseBannerReducer,
  releaseBannerAdminReducer: ReleaseBannerAdminReducer,
});

/**
 * Root reducer that intercepts RESET_ALL_REDUCERS.
 * Passing `undefined` as state to appReducer causes every slice reducer
 * to fall back to its own initialState, effectively wiping all in-memory
 * Redux data on logout.
 */
const rootReducer = (state, action) => {
  if (action.type === 'RESET_ALL_REDUCERS') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;